import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';

import * as leakFileLib from 'libs/leakFileLib';
import * as normal from 'libs/normalizer';

// action types
const INITIAL_STORE = 'leakFile/INITIAL_STORE';
const CHANGE_PARAM = 'leakFile/CHANGE_PARAM';
const RELOAD_LEAKFILE = 'leakFile/RELOAD_LEAKFILE';
const GET_LEAKFILE = 'leakFile/GET_LEAKFILE';
const DELETE_LEAKFILE = 'leakFile/DELETE_LEAKFILE';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeParam = createAction(CHANGE_PARAM);
export const reloadLeakFile = createAction(RELOAD_LEAKFILE);
export const getLeakFile = createAction(GET_LEAKFILE, leakFileLib.getLeakFile);
export const deleteLeakFile = createAction(DELETE_LEAKFILE, leakFileLib.deleteLeakFile);

// initial state
const initialState = fromJS({
  data: {
    result: -1,
    success: [],
    fail: []
  },
  indexByNo: {},
  needReload: false,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'leakFileNo', order: 'DESC' }]
  }),
  totalPages: 0,
  totalCount: 0
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    [RELOAD_LEAKFILE]: (state, action) => {
      return state.set('needReload', true);
    },
    ...pender({
      type: GET_LEAKFILE,
      onSuccess: (state, action) => {
        const { data } = action.payload;
        const { offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = data.list.length > 0 ? data.list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);
        const stateObj = normal.payloadDataSaver(state, 'data', data);
        return stateObj
          .set('needReload', false)
          .set('totalPages', totalPages)
          .set('totalCount', totalCount)
          .set('indexByNo', fromJS(normal.listIndexByNo(data.list, 'leakFileNo')));
      },
      onFailure: (state, action) => {
        console.log('GET_LEAKFILE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: DELETE_LEAKFILE,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('DELETE_LEAKFILE 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/leakFile.js